export const THEADERMOCK = [
  { name: "Nome do Produto", value: "name" },
  { name: "Nº Patrimônio", value: "asset_number" },
  { name: "Status", value: "status" },
  { name: "Local", value: "physical_location" },
  { name: "Responsável", value: "responsible" },
  { name: "Valor", value: "purchase_amount" },
];

export const SELECTFILTER = [
  { name: "Produto", value: 1 },
  { name: "Nº Patrimônio", value: 2 },
  { name: "Local", value: 3 },
  { name: "Responsável", value: 4 },
  { name: "Descrição", value: 5 },
];

//"Disponível" | "Em uso" | "Em manutenção" | "Vendido" | "Doado"
export const STATUS_LIST_FILTER = [
  { name: "Disponível", value: 1 },
  { name: "Em uso", value: 2 },
  { name: "Em manutenção", value: 3 },
  { name: "Vendido", value: 4 },
  { name: "Doado", value: 5 },
];

export const LIST_LOCAL_FILTER = [
  { name: "Home Office", value: 1 },
  { name: "Tegra", value: 2 },
];

export const CASE_FILTER = ["name", "asset_number", "physical_location", "responsible", "description"];

export const SELECTMODAL = [
  { id: 1, name: "Doado" },
  { id: 2, name: "Vendido" },
];
